import React from "react";
import { Modal } from "react-bootstrap";

const ImageModal = ({ show, onHide, imageUrl, imageAlt }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="image-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="visually-hidden">
          {imageAlt || "Wildlife Image"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        {imageUrl && (
          <img
            src={imageUrl}
            alt={imageAlt || "Wildlife Image"}
            className="w-100"
            style={{
              maxHeight: "90vh",
              objectFit: "contain",
              borderRadius: "0 0 0.375rem 0.375rem"
            }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ImageModal;
